import React from 'react';

import * as actions from '../../redux/actions';
import CommonService from '../../../../services/commonService';
import { ThemeFiveContactForm, ThemeFiveTitles } from '../..';
import HeroSection from '../../common/HeroSection/HeroSection';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import KuposHelmet from '../../../common/KuposHelmet';

const ThemeFiveContactUsScreen = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;
  return (
    <div>
      <KuposHelmet />

      <HeroSection
        height={'30vh'}
        heroImage={getIcons('contactUsBanner', operator)}
        title={'Contacto'}
        description={'Home / Contacto'}
      />
      <ThemeFiveTitles className="mb-4" smallHeading="Comunícate" boldHeading="CON NOSOTROS" />

      <ContactIcons operator={operator} />
      {operator && operator.operator_name === 'centraltour' ? (
        <div style={{ height: '100px' }} />
      ) : (
        <ThemeFiveContactForm />
      )}
    </div>
  );
};

const getContactIcons = operator => {
  if (operator) {
    return [
      {
        image: getIcons('contactHeadphone'),
        caption: operator.phone_number ? operator.phone_number : 'N/A',
        borderRight: 'borderRight-about-icons',
      },
      {
        image: getIcons('contactMail'),
        caption: operator.email ? operator.email : 'N/A',
      },
    ];
  } else return [];
};

const ContactIcons = ({ operator }) => {
  return (
    <div
      className="new-container"
      style={{ display: 'flex', alignItems: 'baseline', marginBottom: '50px' }}
    >
      <style>
        .borderRight-about-icons {'{'}
        border-right: 1px solid{' '}
        {operator && operator.color_codes && operator.color_codes.secondary_color
          ? operator.color_codes.secondary_color
          : '3fff'}
        ;{'}'}
      </style>
      {getContactIcons(operator).map((val, i) => {
        return (
          <div
            key={i}
            className={val.borderRight ? val.borderRight : ''}
            style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '50%' }}
          >
            <div>
              <img
                src={val.image}
                alt=""
                className="contact-item-image"
                style={{ width: '60px', marginBottom: '10px' }}
              />
            </div>
            <div className="font10">{val.caption}</div>
          </div>
        );
      })}
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFiveContactUsScreen);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/ThemeFivePages/ThemeFiveContactUsScreen.js